import SearchIcon from '@assets/icons/search.svg';

interface ResultTextProps {
  totalProducts: number;
  search: string;
  className?: string;
}

export const ResultText = ({
  totalProducts,
  search,
  className
}: ResultTextProps) => (
  <>
    {totalProducts > 0 && (
      <div className={className}>
        {search && (
          <div className="flex items-center justify-start gap-x-[10px] text-gray-darkest lg:gap-x-4">
            <SearchIcon width={18} height={18} />
            <output className="text-lg w-full lg:text-xl lg:truncate lg:flex-1 lg:overflow-visible lg:max-w-68 lg:font-normal">
              Resultados para: &apos;{search}&apos;
            </output>
          </div>
        )}
      </div>
    )}
  </>
);
